import { StipendsCard } from "../components/StipendsCard";
import { useEffect, useState } from "react";
import { PageWithTitle } from "@common/components/PageLayout/PageWithTitle";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";
import { CreateStipendSheet } from "../sheets/CreateStipendSheet";
import { ViewStipendDetailsSheet } from "../sheets/ViewStipendDetailsSheet";
import { NavigationTabs } from "@/components/ui/navigation-tabs";
import {
  tabs,
  useStipendWallets,
  EmployeeStipendsSelectedTab,
} from "./useEmployeeStipendsTabs";
import { StipendWalletResponse } from "@common/utils/graphql";
import { FileDashed } from "@phosphor-icons/react";
import { NoResultsCard } from "@common/components/NoResultsCard";
import { AddBankAccountBanner } from "@common/components/AddBankAccountBanner";

/*
 This needs to get updated so we can properly paginate all the stipends
 and have them split up into active and expired. This can be done by
 having a managed hook and leveraging the useStipendWalletsQuery hook
 with currentPage and tab as arguments.
*/

export const StipendsPage = ({ tab }: { tab: EmployeeStipendsSelectedTab }) => {
  const [currentPage] = useState(0);

  const { data, loading, refetch } = useStipendWallets(tab);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const [createExpenseStipendWallet, setCreateExpenseStipendWallet] = useState<
    StipendWalletResponse | undefined
  >(undefined);
  const [viewStipend, setViewStipend] = useState<
    StipendWalletResponse | undefined
  >(undefined);

  const stipendsCards = (
    <>
      <AddBankAccountBanner />
      <div className="flex flex-col justify-between">
        {data?.map((stipend) => (
          <StipendsCard
            stipend={stipend}
            onClaim={setCreateExpenseStipendWallet}
            onViewDetails={() => setViewStipend(stipend)}
            key={stipend.id}
          />
        ))}
      </div>
    </>
  );

  let body = <FullPageLoader />;
  if (!loading || data.length > 0) {
    if (data.length === 0) {
      body = (
        <NoResultsCard
          Icon={FileDashed}
          header={`No ${tab.toLowerCase()} stipends`}
          body={`You have no ${tab.toLowerCase()} stipends.`}
        />
      );
    } else {
      body = stipendsCards;
    }
  }

  const onHandleSubmit = () => {
    setCreateExpenseStipendWallet(undefined);
    refetch();
  };

  const onClose = () => {
    if (createExpenseStipendWallet) {
      setCreateExpenseStipendWallet(undefined);
    } else {
      setViewStipend(undefined);
    }
  };

  return (
    <PageWithTitle title="Stipends">
      <NavigationTabs tabs={tabs} selectedTab={tab} />
      {body}
      <ViewStipendDetailsSheet
        isOpen={!!viewStipend}
        stipend={viewStipend!}
        onSubmitClaim={() => {
          setCreateExpenseStipendWallet(viewStipend);
          setViewStipend(undefined);
        }}
        onClose={onClose}
      />
      <CreateStipendSheet
        stipendWallet={createExpenseStipendWallet}
        onSubmitted={onHandleSubmit}
        isOpen={!!createExpenseStipendWallet}
        onClose={onClose}
      />
    </PageWithTitle>
  );
};
